<template>
	<div class="main-containter"  id="top" v-title data-title="和华利盛">
		<FHeader :checkId="23"></FHeader>
		<FOtherBanner :name1="'关于我们'" :name2="'About Us'"></FOtherBanner>
		<!-- <FTitle></FTitle> -->
		<article>
			<div style="padding-left: 18%;padding-top: 20px;">
				<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/' }" style="cursor: pointer;font-weight: 400 !improt;color:black !improt;">首页</el-breadcrumb-item>
				<el-breadcrumb-item style="cursor: default;">关于我们</el-breadcrumb-item>
				<el-breadcrumb-item style="color:black;cursor: default;">律所简介</el-breadcrumb-item>
			</el-breadcrumb>
			</div>
			<div class="aboutContent">
				<div class="left">
					<span style="font-size: 26px;font-weight: 900;color: #98273A;">律所简介</span>
					<span style="padding-top: 5px;color: #98273A;">Company Profile</span>
					<span style="width: 25px;margin-top: 7px;height: 5px;background-color: #98273A;"></span>
					<span style="padding-top: 20px;font-size: 14px;line-height: 28px;">上海和华利盛律师事务所经上海市司法局核准于2001年在上海市黄浦区成立，先后在重庆、西安、唐山、郑州、海口、太原、合肥设有分所，同时在香港、悉尼等地设有办公室或战略合作伙伴。</span>
					<span style="padding-top: 20px;font-size: 14px;line-height: 28px;">中文名“和华利盛”：包含“和为贵”、“和谐中华”、“专注商业”、“繁荣昌盛”之义。英文名HAWORTH & LEXON：英语与拉丁文的组合，意为“法律之上的价值”。</span>
					<span style="padding-top: 20px;font-size: 14px;line-height: 28px;">和华利盛自成立以来，积极学习国际、国内领先律所的先进运营经验，践行“专业、精致”的海派律师理念，以助力客户成长、成功为目标，以团队合作为基石，以专业化服务为依托，多年来，赢得了包括多家世界500强企业在内的众多客户的认可，在律师业和社会各界享有良好的声誉。</span>
					<span style="padding-top: 20px;font-size: 14px;line-height: 28px;">和华利盛执业律师多数具有国内及国外著名大学硕士或博士学位，能在包括新能源、汽车、医疗、教育、网络安全、银行、保险、电力、通讯 、软件、高新技术、矿产等多个行业领域提供专业法律服务。</span>
					<span style="padding-top: 20px;font-size: 14px;line-height: 28px;">和华利盛自成立以来，多次获得著名法律杂志The Asia Pacific Legal 500（亚太法律500强）重点推荐，被选任为“世博推荐法律服务供应商”，获评“上海市优秀律师事务所”，被ALB（亚洲法律杂志－中国版）评为“最值得关注的10家律师事务所”。</span>
				</div>
				<div class="right">
					<img src="https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/indexBusinessArea.png" alt="">
				</div>
			</div>
			<div class="middle">
				<div style="float: left;margin-left: 22%;padding-top: 100px;text-align: center;">
					<div style="font-size: 14px;color: white;">专业人员</div>
					<div style="padding-top: 30px;font-size: 40px;font-weight: 800;color: white;">100+</div>
				</div>
				<div style="float: left;margin-left: 11%;padding-top: 100px;text-align: center;">
					<div style="font-size: 14px;color: white;">分所及办事处</div>
					<div style="padding-top: 30px;font-size: 40px;font-weight: 800;color: white;">7</div>
				</div>
				<div style="float: left;margin-left: 11%;padding-top: 100px;text-align: center;">
					<div style="font-size: 14px;color: white;">服务客户</div>
					<div style="padding-top: 30px;font-size: 40px;font-weight: 800;color: white;">500+</div>
				</div>
				<div style="float: left;margin-left: 11%;padding-top: 100px;text-align: center;">
					<div style="font-size: 14px;color: white;">战略伙伴</div>
					<div style="padding-top: 30px;font-size: 40px;font-weight: 800;color: white;">50+</div>
				</div>
			</div>
			<div class="bottom" style="width: 64%;padding: 30px 18%;">
				<div class="bottomTop" style="text-align: center;">
					<div style="font-size: 26px;font-weight: 900;color: #98273A;">合作伙伴</div>
					<div style="padding-top: 5px;font-size: 14px;color: #98273A;">Partners</div>
				</div>
				<div class="bottomBottom" style="height:350px;padding-top:30px;">
					<div style="height: 120px;">
						<div v-for="(item,index) in [1,2,3,4,5,35]" :key="index" :style="{float: 'left',width: 'calc(16.7% - 12px)',border: '1px solid #DFDFDF','margin-right':item==35?'':'10px',height:'120px'}">
							<img style="width: 100%;height:120px" :src="'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/partners/'+item+'.png'">
						</div>
					</div>
					<div style="height: 120px;margin-top:30px;">
						<div v-for="(item,index) in [6,7,8,9,10,36]" :key="index" :style="{float: 'left',width: 'calc(16.7% - 12px)',border: '1px solid #DFDFDF','margin-right':item==36?'':'10px',height:'120px'}">
							<img style="width: 100%;height:120px" :src="'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/partners/'+item+'.png'">
						</div>
					</div>
					
				</div>
			</div>
		</article>
		<Footer></Footer>
	</div>
</template>

<script>
	import FHeader from "../../components/f/FHeader.vue"
	import FOtherBanner from "../../components/f/FOtherBanner.vue"
	import Footer from "../../components/f/Footer.vue"

	import {queryScenicList,querySoftwareList,queryArticleList} from "@/api/front";
	export default {
		name: "Index",
		components: {
			FHeader,
			FOtherBanner,
			Footer
		},
		data() {
			return {
			}
		},
		mounted() {
			document.getElementById("top").scrollIntoView({ behavior: "smooth" });
		},
		activated(){
			document.getElementById("top").scrollIntoView({ behavior: "smooth" });
		},
		methods: {
			
			toIndex(){
				this.$router.push(
					{
						path:'/',
					}
				);
			},
		}
	}
</script>

<style lang="scss" scoped>
	.main-containter {
		min-width: 1000px;
		.news{
			background-image: url(../../assets/fImage/homeNewsBg.jpg);
			background-size: cover;
		}
	}
</style>
<style lang="scss" scoped="scoped">

	span /deep/ .el-breadcrumb__inner{
		font-weight: 400 !important;
		color: #606266 !important;
		cursor: default !important;
	}
	span /deep/ .el-breadcrumb__inner.is-link{
		font-weight: 400 !important;
		color: #606266 !important;
		cursor: pointer !important;
	}
	.middle{
		background: url('https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/adoutUsMiddle.png') no-repeat;
		background-size:100% 100%;
		width: 100%;
		height: 300px;
		margin-bottom: 70px;
		margin-top: 100px;
	}
	.aboutContent{
		width: 64%;
		padding: 30px 18%;
		padding-top: 80px;
		display: flex;
		flex-direction: row;
		// justify-content: space-between;
		.left{
			width: 61%;
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			.cmpName{
				width: 100%;
				height: 50px;
				font-size: 28px;
				font-family: Adobe Heiti Std R;
				color: #2E2E2E;
				line-height: 33px;
				border-bottom: 2px solid #469DFF;
			}
			.cmpInfo{
				width: 600px;
				padding: 10px 0;
				font-size: 21px;
				font-family: Adobe Heiti Std R;
				color: #838383;
				line-height: 33px;
			}
			.button{
				width: 120px;
				height: 36px;
				color: #FFFFFF;
				font-size: 16px;
				line-height: 36px;
				text-align: center;
				border-radius: 20px;
				background-color: #1A86FF;
				cursor: pointer;
				margin-top: 20px;
			}
		}
		.right{
		padding-left: 7%;
    height: 100%;
		}
	}
</style>
